import { DropDownItemType } from 'common/components/drop-downs/legacy/dropDownItemType';
import { ChartDisplayType } from 'features/charts/chart.models';

export const ChartRoutes = [
  {
    isActive: false,
    key: ChartDisplayType.STACKED_BAR,
    label: 'StackedBar'
  },
  {
    isActive: false,
    key: ChartDisplayType.LINE,
    label: 'StackedLine'
  }
] as DropDownItemType[];
